import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../utils/styles';

export const DestinationsListSkeletonLoaderWrapper = styled.div`
  margin-top: ${toRem(16)};
  margin-bottom: ${toRem(16)};
  opacity: 0.9;
  .destinations-list-header {
    width: ${toRem(500)};
    height: ${toRem(50)};
    margin-bottom: ${toRem(24)};
    border-radius: ${toRem(8)};
    @media ${mediaQuery.mobileOnly} {
      width: 70%;
      height: ${toRem(40)};
      margin-bottom: ${toRem(16)};
    }
  }
  .destinations-list-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${toRem(12)};

    .destinations-list-card {
      display: flex;
      gap: ${toRem(16)};
      align-items: center;
      width: 100%;
      height: ${toRem(85)};
      border-radius: ${toRem(8)};
      padding: ${toRem(8)} ${toRem(16)};
      background-color: #f0f0f0;
      @media ${mediaQuery.mobileOnly} {
        height: ${toRem(70)};
      }
      .destinations-list-card_image {
        width: ${toRem(180)};
        height: ${toRem(60)};
        border-radius: ${toRem(8)};
        z-index: 1;
        @media ${mediaQuery.mobileOnly} {
          width: ${toRem(80)};
          height: ${toRem(50)};
        }
      }
      .destinations-list-card_text {
        width: ${toRem(200)};
        height: ${toRem(20)};
        border-radius: ${toRem(8)};
        z-index: 1;
        @media ${mediaQuery.mobileOnly} {
          width: ${toRem(120)};
          height: ${toRem(20)};
        }
      }
    }
  }
  .seperator {
    height: ${toRem(1)};
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
  }
`;
